import { buildLoader } from '../util/GenericLoader';
import { getMeasurementsAction } from '../../redux/actions/measurements';

export default buildLoader(getMeasurementsAction);
